var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", [
          _vm.rules.length === 0
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  '\n      No rules have been created yet. Click "Add Rule" to create one.\n    '
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rules.length > 0
            ? _c("div", [
                _c("table", { staticClass: "table table-striped" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.rules, function(rule) {
                      return _c("tr", { key: rule.uuid }, [
                        _c("td", [_vm._v(_vm._s(rule.rule_type))]),
                        _vm._v(" "),
                        _c("td", [
                          rule.rule_config &&
                          rule.rule_config.school_uuids &&
                          rule.rule_config.school_uuids.length > 0
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      rule.rule_config.school_uuids.length
                                    ) +
                                    " school(s)\n              "
                                )
                              ])
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v("No schools selected")
                              ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              class: rule.enabled
                                ? "label label-success"
                                : "label label-default"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    rule.enabled ? "Enabled" : "Disabled"
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-default",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.editRule(rule)
                                }
                              }
                            },
                            [_vm._v("\n                Edit\n              ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs",
                              class: rule.enabled
                                ? "btn-warning"
                                : "btn-success",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.toggleRuleStatus(rule)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(rule.enabled ? "Disable" : "Enable") +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-danger",
                              attrs: { disabled: !_vm.canManageSubgroups },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRule(rule)
                                }
                              }
                            },
                            [_vm._v("\n                Delete\n              ")]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: !_vm.canManageSubgroups },
                on: { click: _vm.showAddRuleForm }
              },
              [_vm._v("\n        Add Rule\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n        Close\n      ")]
            )
          ]),
          _vm._v(" "),
          _vm.showRuleForm
            ? _c("div", { staticClass: "panel panel-default" }, [
                _c("div", { staticClass: "panel-heading" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.editingRule ? "Edit Rule" : "Add Rule"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveRule.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ruleForm.enabled,
                                  expression: "ruleForm.enabled"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.ruleForm.enabled)
                                  ? _vm._i(_vm.ruleForm.enabled, null) > -1
                                  : _vm.ruleForm.enabled
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.ruleForm.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.ruleForm, "enabled", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v("\n                Enabled\n              ")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "help-block" }, [
                          _vm._v(
                            "When enabled, this rule will automatically assign users to this subgroup."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "rule_type" } }, [
                          _vm._v("Rule Type")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ruleForm.rule_type,
                                expression: "ruleForm.rule_type"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "rule_type",
                              required: "",
                              disabled: ""
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.ruleForm,
                                  "rule_type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "school" } }, [
                              _vm._v("School-based")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "help-block" }, [
                          _vm._v(
                            "Currently only school-based rules are supported."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group schools" }, [
                        _c("legend", [_vm._v("Schools")]),
                        _vm._v(" "),
                        _vm.loadingSchools
                          ? _c("div", { staticClass: "text-muted" }, [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(" Loading schools...\n            ")
                            ])
                          : _c("div", [
                              _vm.schools.length === 0
                                ? _c(
                                    "div",
                                    { staticClass: "alert alert-warning" },
                                    [
                                      _vm._v(
                                        "\n                No schools found in this domain.\n              "
                                      )
                                    ]
                                  )
                                : _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "schools-filter-controls"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.schoolSearchTerm,
                                                  expression: "schoolSearchTerm"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                placeholder:
                                                  "Search schools...",
                                                "aria-label": "Filter schools"
                                              },
                                              domProps: {
                                                value: _vm.schoolSearchTerm
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.schoolSearchTerm =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "filter-options" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "checkbox" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.showSelectedOnly,
                                                        expression:
                                                          "showSelectedOnly"
                                                      }
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.showSelectedOnly
                                                      )
                                                        ? _vm._i(
                                                            _vm.showSelectedOnly,
                                                            null
                                                          ) > -1
                                                        : _vm.showSelectedOnly
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.showSelectedOnly,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.showSelectedOnly = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.showSelectedOnly = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.showSelectedOnly = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        Show selected only\n                      "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "selected-count" },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ruleForm.school_uuids
                                                        .length
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" of "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(_vm.schools.length)
                                                  )
                                                ]),
                                                _vm._v(
                                                  " schools selected\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.filteredSchools.length === 0
                                      ? _c(
                                          "div",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              "\n                  No schools match your search.\n                "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "schools-list" },
                                          _vm._l(_vm.filteredSchools, function(
                                            school
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: school.uuid,
                                                staticClass: "checkbox"
                                              },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.ruleForm
                                                            .school_uuids,
                                                        expression:
                                                          "ruleForm.school_uuids"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      "aria-label":
                                                        "select school: " +
                                                        school.name
                                                    },
                                                    domProps: {
                                                      value: school.uuid,
                                                      checked: Array.isArray(
                                                        _vm.ruleForm
                                                          .school_uuids
                                                      )
                                                        ? _vm._i(
                                                            _vm.ruleForm
                                                              .school_uuids,
                                                            school.uuid
                                                          ) > -1
                                                        : _vm.ruleForm
                                                            .school_uuids
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.ruleForm
                                                              .school_uuids,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = school.uuid,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.ruleForm,
                                                                "school_uuids",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.ruleForm,
                                                                "school_uuids",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.ruleForm,
                                                            "school_uuids",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(school.name) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                  ])
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "submit", disabled: _vm.saving }
                          },
                          [
                            _vm.saving
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin"
                                  }),
                                  _vm._v(" Saving...")
                                ])
                              : _c("span", [_vm._v("Save")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button", disabled: _vm.saving },
                            on: { click: _vm.cancelRuleForm }
                          },
                          [_vm._v("\n              Cancel\n            ")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("small", [
        _vm._v(
          "Rules automatically assign users to this subgroup based on the users attributes."
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Rule Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Schools")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Actions")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }